import Controller from '@ember/controller';
import moment from 'moment-timezone';

import { action, computed, set } from '@ember/object';

import { inject as iService } from '@ember/service';

import { inject as iController } from '@ember/controller';

export default class ListController extends Controller {
  @iService intl;
  @iService session;
  @iController('application') applicationController;

  queryParams = ['type'];
  type = null;

  filterSpecDef = [
    {
      query: 'discesa',
      name: 'Alpine skiing',
    },
    {
      query: 'snowboard',
      name: 'Snowboard',
    },
    {
      query: 'telemark',
      name: 'Telemark',
    },
    {
      query: 'fondo',
      name: 'Nordic skiing',
    },
  ];

  filterAgeDef = [
    {
      query: '0',
      name: 'Toddlers (3 - 4)',
    },
    {
      query: '4',
      name: 'Kids (4-8)',
    },
    {
      query: '8',
      name: 'Teens (8-18)',
    },
    {
      query: '18',
      name: 'Adults (18+)',
    },
  ];

  @computed('session.option_field.ecommerce_filter.spec.hide')
  get showFilterSpec() {
    return !this.session.option_field?.ecommerce_filter?.spec?.hide;
  }

  @computed('applicationController.status')
  get filterStatusName() {
    const { status } = this.applicationController || {};

    if (status === 108 || status === '108') {
      return 'seasonal course';
    } else if (status === 106 || status === '106') {
      return 'groups';
    }

    return null;
  }

  @computed('session.option_field.ecommerce_filter.type.values')
  get filterType() {
    return this.session.option_field?.ecommerce_filter?.type?.values || null;
  }

  @computed('session.option_field.ecommerce_filter.spec.values', 'filterSpecDef')
  get filterSpec() {
    const ecommerce_filter = this.session.option_field?.ecommerce_filter;

    return ecommerce_filter?.spec?.values || this.filterSpecDef;
  }

  @computed('session.option_field.ecommerce_filter.age.hide')
  get showFilterAge() {
    return !this.session.option_field?.ecommerce_filter?.age?.hide;
  }

  @computed('session.option_field.ecommerce_filter.comp.hide')
  get showFilterComp() {
    return !this.session.option_field?.ecommerce_filter?.comp?.hide;
  }

  @computed('session.option_field.ecommerce_filter.level.hide')
  get showFilterLevel() {
    return !this.session.option_field?.ecommerce_filter?.level?.hide;
  }

  @computed('session.option_field.ecommerce_filter.age.values', 'filterAgeDef')
  get filterAge() {
    const ecommerce_filter = this.session.option_field?.ecommerce_filter;

    return ecommerce_filter?.age?.values || this.filterAgeDef;
  }

  @computed(
    'session.option_field.comprensori.@each.ecommerce_private',
    'session.option_field.comprensori.@each.ecommerce_collettive',
    'type'
  )
  get allComp() {
    const comprensori = this.session.option_field?.comprensori;

    if (!Array.isArray(comprensori)) {
      return [];
    }

    const { type } = this;
    const filterPrivate = type === 'private';
    const filterGroup = type === 'group';

    return comprensori.filter((c) => {
      if (filterPrivate) {
        return c.ecommerce_private;
      }
      if (filterGroup) {
        return c.ecommerce_collettive;
      }
      return c.ecommerce_private || c.ecommerce_collettive;
    });
  }

  @computed('session.option_field.{comprensori,livelli_sci}')
  get levelsComp() {
    const livelli_sci = this.session.option_field?.livelli_sci;

    if (!Array.isArray(livelli_sci)) {
      return [];
    }

    return livelli_sci.filter((c) => !c.hide_ecommerce);
  }

  @computed('type', 'applicationController.prodotti.products.length')
  get productFiltered() {
    const { prodotti } = this.applicationController || {};
    const { products } = prodotti || [];

    if (!Array.isArray(products) || !this.type) {
      return products || [];
    }

    return this.type === 'group'
      ? products.filter((p) => p.product_status_id !== 92)
      : products.filter((item) => item.product_status_id === 92);
  }

  @computed('type', 'applicationController.prodotti.products.length')
  get productCoursesFiltered() {
    const { prodotti } = this.applicationController || {};
    const { products } = prodotti || [];

    return Array.isArray(products) ? products.filter((p) => p.product_status_id !== 92) : [];
  }

  @computed('type', 'applicationController.prodotti.products.length')
  get productPrivateFiltered() {
    const { prodotti } = this.applicationController || {};
    const { products } = prodotti || [];

    return Array.isArray(products) ? products.filter((item) => item.product_status_id === 92) : [];
  }

  @action
  setReload(variable, value, variable1 = null, value1 = null, type = null) {
    // {{on}} appends the DOM event as last arg; keep optional params clean
    if (variable1 instanceof Event) {
      variable1 = null;
    }
    if (type instanceof Event) {
      type = null;
    }

    set(this, `applicationController.${variable}`, value);

    if (variable1) {
      set(this, `applicationController.${variable1}`, value1);
    }

    if (type) {
      set(this, 'type', type);
    }

    this.applicationController.loadDataTask.perform();
  }

  @action
  updateDay(selected) {
    // was {{action 'updateDay' value='date'}} — unwrap power-calendar payload
    const date = selected?.date ?? selected;
    set(this, `applicationController.date`, moment(date).format('YYYY-MM-DD'));
    this.applicationController.loadDataTask.perform();
    set(this, 'showChangeDate', false);
  }

  @action
  updateMonth(selected) {
    // was {{action 'updateMonth' value='date'}} — unwrap power-calendar payload
    const date = selected?.date ?? selected;
    set(this, `applicationController.date`, moment(date).format('YYYY-MM-DD'));
    this.applicationController.loadDataTask.perform();
  }
}
